import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';

/**
 * Eén centrale privacyverklaring voor website én app, op de landingspagina
 * (tekst in landing/assets/js/content.js, achtergrond in docs/legal/AVG.md).
 * De app houdt bewust geen eigen kopie bij: twee versies lopen uit elkaar
 * (de app-tekst bleef in juli 2026 staan terwijl de website in oktober bijgewerkt werd).
 */
export const PRIVACY_STATEMENT_URL = 'https://mechanicsinmotion.be/privacy.html';

/** URL van de privacyverklaring in de taal van de app (de landing kent `?lang=nl|en`). */
export function privacyStatementUrl(language: string): string {
  return `${PRIVACY_STATEMENT_URL}?lang=${language === 'en' ? 'en' : 'nl'}`;
}

/** Oude links en bladwijzers naar /privacy in de app sturen door naar de centrale verklaring. */
export const redirectToPrivacyStatement: CanActivateFn = () => {
  const language = inject(TranslocoService).getActiveLang();
  inject(DOCUMENT).location.assign(privacyStatementUrl(language));
  return false;
};
